// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encryptionSecrectKey: 'cEA3RJ7Flz',
  // appUrl: 'http://localhost:5001',
  // betaAppUrl: 'http://localhost:5001',
  //  appUrl: 'http://api.chemrobotics.com'

  appUrl: 'https://api.chemrobotics.com',

  //Old node
  betaAppUrl: 'https://apibeta.chemrobotics.com',

  // New node
  // betaAppUrl: 'https://backend.chemrobotics.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
